var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-container",attrs:{"id":"back-container"}},[_c('router-link',{attrs:{"to":{name: _vm.page_name}}},[_c('span',{staticClass:"icon-back"},[_c('IconBase',[_c('IconArrowBack')],1)],1),_vm._v(" Back ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }